<template>
  <div>
    <!-- 搜索条件 -->
    <div class="search clear">
      <el-form :inline="true" size="mini">
        <el-form-item label="用户ID">
          <el-input placeholder="用户ID" clearable></el-input>
        </el-form-item>
        <el-form-item label="类别">
          <el-select style="width:100px;" clearable>
            <el-option label="qq" value="0"></el-option>
            <el-option label="百度" value="1"></el-option>
            <el-option label="新浪微博" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary">搜索</el-button>
        </el-form-item>
      </el-form>
    </div>

    <!-- 表格 -->
    <div class="table">
      <el-table
        :data="tableData"
        size="small"
        height="100%"
        border
        style="width: 100%; height:100%;"
      >
        <el-table-column prop="userID" label="用户ID"></el-table-column>
        <el-table-column prop="userNick" label="用户昵称"></el-table-column>
        <el-table-column prop="thirdNick" label="第三方昵称"></el-table-column>
        <el-table-column label="头像">
          <template slot-scope="scope">
            <el-avatar shape="square" size="large" :src="scope.row.head"></el-avatar>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="120">
          <template slot-scope="scope">
            <el-button
              @click.native.prevent="deleteRow(scope.$index, tableData)"
              type="text"
              size="small"
            >编辑</el-button>
            <el-button
              @click.native.prevent="deleteRow(scope.$index, tableData)"
              type="text"
              size="small"
            >删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 分页 -->
    <div class="pagination">
      <el-pagination background layout="prev, pager, next, total" :total="1000"></el-pagination>
    </div>
  </div>
</template>

<script>
import { tableData } from "../../../demo/user/thirdloginlist";
export default {
  name: "user_thirdloginlist",
  data() {
    return {
      tableData
    };
  }
};
</script>

<style scoped>
</style>